// 学校审批
import service from "@/utils/request";

//  入园审批列表
export function getApplyList(data) {
  return service({
    url: "/service/admin/street/apply_list",
    method: "get",
    params: data,
  });
}

//  审批操作
export function applyOperate(data) {
  return service({
    url: "/service/admin/street/operate",
    method: "post",
    params: data,
  });
}

// 学校列表
export function getShcoolList(data) {
  return service({
    url: "/service/admin/school/list",
    method: "post",
    params: data,
  });
}

//  密码重置
export function resetPass(data) {
  return service({
    url: "/service/admin/school/resetPwd",
    method: "post",
    params: data,
  });
}

//  学校列表头部信息统计
export function getSchoolStatistics(data) {
  return service({
    url: "/service/admin/school/statistics",
    method: "get",
    params: data,
  });
}

//  数据报表列表
export function getReportList(data) {
  return service({
    url: "/service/admin/school/report_list",
    method: "get",
    params: data,
  });
}
